import React, { useEffect, useRef, useState } from 'react';
import './FAQ.css';

const FAQ = ({ onOpenModal }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: isMobile ? '0px' : '-150px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const faqs = [
    {
      question: 'Combien coûte une intégration IA ?',
      answer: 'Le coût varie selon la complexité du projet. Après un premier échange, nous vous proposons un devis personnalisé adapté à vos besoins et votre budget. Les projets peuvent aller de quelques centaines d\'euros pour des automatisations simples à quelques milliers pour des solutions plus complexes.'
    },
    {
      question: 'En combien de temps peut-on avoir un prototype ?',
      answer: "Selon la complexité, un premier prototype fonctionnel peut être livré entre 2 et 6 semaines. Notre approche agile nous permet de vous montrer rapidement des résultats concrets et d'itérer ensemble."
    },
    {
      question: 'Quelles technologies utilisez-vous ?',
      answer: "Nous utilisons un ensemble de technologies modernes telles que LangChain/LangGraph, des bases vectorielles, des graphes de connaissances et les API des principaux modèles IA (OpenAI, Claude, Mistral). Nous nous appuyons également sur des outils web comme React ainsi que sur des pipelines d'OCR, de scrapping et de traitement de données selon les besoins du projet."
    },
    {
      question: 'Comment se déroule le premier appel ?',
      answer: "Lors du premier appel de 30 minutes, nous discutons de vos défis actuels, de vos objectifs, et explorons ensemble les opportunités d'IA pour votre entreprise. C'est un échange sans engagement qui nous permet de comprendre vos besoins et de vous proposer une solution adaptée."
    },
    {
      question: 'Dois-je avoir des compétences techniques ?',
      answer: "Non, aucune compétence technique n'est requise de votre côté. Je m'occupe de toute la partie technique, de la conception à l'intégration. Mon objectif est de vous livrer une solution clé en main, simple à utiliser."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const column1Faqs = faqs.slice(0, 3);
  const column2Faqs = faqs.slice(3, 5);

  return (
    <section id="faq" className={`faq ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
      <div className="faq-container">
        <h2 className={`section-title fade-in-up ${isVisible ? 'visible' : ''}`}>Je parie que vous avez au moins<br />une de ces <span className="highlight-questions">questions</span> !</h2>
        <div className="faq-columns">
          <div className="faq-column">
            {column1Faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item fade-in-up delay-${(index + 1) * 100} ${openIndex === index ? 'open' : ''} ${isVisible ? 'visible' : ''}`}
              >
                <button 
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.question}</span>
                  <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="faq-column">
            {column2Faqs.map((faq, index) => (
              <div 
                key={index + 3} 
                className={`faq-item fade-in-up delay-${(index + 4) * 100} ${openIndex === (index + 3) ? 'open' : ''} ${isVisible ? 'visible' : ''}`}
              >
                <button 
                  className="faq-question"
                  onClick={() => toggleFAQ(index + 3)}
                >
                  <span>{faq.question}</span>
                  <span className="faq-icon">{openIndex === (index + 3) ? '−' : '+'}</span>
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
            <div className={`faq-item faq-contact-item fade-in-up delay-600 ${isVisible ? 'visible' : ''}`}>
              <div className="faq-contact-content">
                <h3>D'autres questions ?</h3>
                <button onClick={onOpenModal} className="contact-button">
                  <img src="/photo/equipe/photo-cv-entier.png" alt="" className="contact-button-avatar" />
                  <span className="button-text">
                    <span className="text-default">Prendre rendez-vous</span>
                    <span className="text-hover">On est partis ?</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
